export const EmailNotification = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 2C17.7909 2 16 3.79086 16 6C16 8.20914 17.7909 10 20 10C22.2091 10 24 8.20914 24 6C24 3.79086 22.2091 2 20 2ZM18 6C18 4.89543 18.8954 4 20 4C21.1046 4 22 4.89543 22 6C22 7.10457 21.1046 8 20 8C18.8954 8 18 7.10457 18 6Z"
      fill="currentColor"
    />
    <path
      d="M20 12C19.3875 12 18.7964 11.9082 18.2397 11.7376C16.3224 12.5504 14.2137 13 12 13C8.21621 13 4.7392 11.6866 2 9.49074V17C2 18.6569 3.34315 20 5 20H19C20.6569 20 22 18.6569 22 17V11.6586C21.3744 11.8797 20.7013 12 20 12Z"
      fill="currentColor"
    />
    <path
      d="M14 6C14 5.29873 14.1203 4.62556 14.3414 4H5C3.40887 4 2.10706 5.2387 2.00628 6.80437C4.54686 9.39371 8.08585 11 12 11C13.3741 11 14.702 10.802 15.9567 10.4331C14.7544 9.33581 14 7.756 14 6Z"
      fill="currentColor"
    />
  </svg>
)

export default EmailNotification
